module.exports = __webpack_public_path__ + "img/icon5.31ed868d.png";